import { IMAGE_FILE_TYPES } from '../../components/modules/files/constants/mimetypes';

export function isValidFileType(file, fileTypes) {
  if (file && fileTypes.split(', ').includes(file.type)) {
    return true;
  }

  return false;
}
export function isValidImageType(file) {
  return isValidFileType(file, IMAGE_FILE_TYPES);
}
